import { useTranslation } from 'react-i18next';
import { ClientOverview } from '../components/ClientOverview';

export function ClientOverviewPage() {
  const { t } = useTranslation();

  return (
    <div data-testid="client-overview-page">
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <h1
            style={{
              fontSize: '1.25rem',
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: 'var(--foreground-heading)',
            }}
          >
            {t('clients.title')}
          </h1>
          <p
            className="mt-[3px]"
            style={{ fontSize: '0.8125rem', color: 'var(--foreground-muted)' }}
          >
            {t('clients.subtitle')}
          </p>
        </div>
      </div>
      <ClientOverview />
    </div>
  );
}
